import * as React from "react";

import PrimaryButton, { PrimaryButtonColorProps } from "./PrimaryButton";
import "./PrimaryButtonAquamarine.scss";

type Props = PrimaryButtonColorProps;

export default class PrimaryButtonAquamarine extends React.PureComponent<Props> {
  render() {
    return (
      <PrimaryButton
        {...this.props}
        primaryButtonColorClassName="PrimaryButtonAquamarine"
      />
    );
  }
}
